import { Injectable, signal, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable()
export class KeycloakInfoService {
  PATH = 'api/info';
  private http = inject(HttpClient);

  private _roles = signal<string[]>([]);
  private _groups = signal<string[]>([]);
  private _time = signal<string[]>([]);
  private _locale = signal<string[]>([]);

  readonly roles = this._roles.asReadonly();
  readonly groups = this._groups.asReadonly();
  readonly time = this._time.asReadonly();
  readonly locale = this._locale.asReadonly();

  readonly isDataLoaded = computed(() => {
    return (
      this._roles().length > 0 && this._groups().length > 0 && this._time().length > 0 && this._locale().length > 0
    );
  });

  constructor() {
    this.initializeData();
  }

  private initializeData(): void {
    this.loadRoles();
    this.loadGroups();
    this.loadLocale();
    this.loadTime();
  }

  private loadRoles(): void {
    this.http
      .get<string[]>(`${this.PATH}/roles`)
      .pipe(tap((roles) => this._roles.set(roles)))
      .subscribe();
  }

  private loadGroups(): void {
    this.http
      .get<string[]>(`${this.PATH}/groups`)
      .pipe(tap((groups) => this._groups.set(groups)))
      .subscribe();
  }

  private loadLocale(): void {
    this.http
      .get<string[]>(`${this.PATH}/locale`)
      .pipe(tap((locale) => this._locale.set(locale)))
      .subscribe();
  }

  private loadTime(): void {
    this.http
      .get<string[]>(`${this.PATH}/time`)
      .pipe(tap((time) => this._time.set(time)))
      .subscribe();
  }

  refreshData(): void {
    this.initializeData();
  }

  getGroups(): Observable<string[]> {
    return this.http.get<string[]>(`${this.PATH}/groups`);
  }

  getLocale(): Observable<string[]> {
    return this.http.get<string[]>(`${this.PATH}/locale`);
  }

  getTime(): Observable<string[]> {
    return this.http.get<string[]>(`${this.PATH}/time`);
  }

  getRoles(): Observable<string[]> {
    return this.http.get<string[]>(`${this.PATH}/roles`);
  }
}
